// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2040-27031
// Figma component name: Pill

/**
 * Pill badge with three variants:
 *   "important"   — yellow background (secondary-container), used for time estimates, booking-only notices
 *   "default"     — dark gray background (on-surface-variant), used for unavailable/info states
 *   "user-choice" — outlined, used for user-selected options
 */
export default function Pill({ text, type = 'default' }) {
  if (type === 'important') {
    return (
      <span className="inline-flex items-center px-[5px] pb-[2px] rounded-[4px] bg-secondary-container border-solid border-[0.5px] border-secondary text-[15px] font-medium leading-5 text-on-surface whitespace-nowrap">
        {text}
      </span>
    )
  }
  if (type === 'user-choice') {
    return (
      <span className="inline-flex items-center px-[5px] pb-[2px] rounded-[4px] border-solid border border-on-surface-variant text-[15px] font-medium leading-5 text-on-surface whitespace-nowrap">
        {text}
      </span>
    )
  }
  // default
  return (
    <span className="inline-flex items-center px-[5px] pb-[2px] rounded-[4px] bg-on-surface-variant text-[15px] font-medium leading-5 text-white whitespace-nowrap">
      {text}
    </span>
  )
}
